module.exports = __webpack_public_path__ + "static/img/icon-menu.e04c99b0.svg";